export default __webpack_public_path__ + "static/son-3eaca766aebde6b7e49f3d16da85d541.png";